import React from 'react';

const Step1CategorySelection = ({
  selectedCategory,
  categories,
  handleCategoryChange,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-8">
      <div className="flex items-center mb-6">
        <div className="w-8 h-8 bg-red-smdd rounded-full flex items-center justify-center mr-4">
          <span className="text-white text-sm font-bold">1</span>
        </div>
        <div>
          <h2 className="text-2xl font-baijamjuree font-extrabold text-black">
            Choose Award Category
          </h2>
          <p className="text-gray-700 mt-1">
            Select the category that best represents your achievement
          </p>
        </div>
      </div>

      <div className="space-y-4 ml-12 mr-12">
        <label
          htmlFor="category"
          className="block text-sm font-medium text-gray-700"
        >
          Award Category
        </label>
        <select
          id="category"
          value={selectedCategory}
          onChange={handleCategoryChange}
          className="w-full px-4 py-3 bg-white border border-gray-300 rounded-2xl focus:border-red-smdd focus:ring-2 focus:ring-red-smdd/20 transition-all text-base text-gray-900 font-baijamjuree"
        >
          <option value="">-- Choose a category --</option>
          {categories.map(cat => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Step1CategorySelection;
